const RELOAD_MARKER = "caru.staleBundleReloadedAt";
const RELOAD_COOLDOWN_MS = 60 * 1000;

const SCHEMA_MISMATCH_PATTERNS = [
  /^\s*validation error of type/i,
  /cannot query field .+ on type/i,
  /unknown type ['"\u2018\u201c]/i,
  /unknown argument ['"\u2018\u201c]/i,
  /must have a selection of subfields/i,
  /must not have a selection since type/i,
];

const parseMessagesFromBody = (body) => {
  if (typeof body !== "string" || body === "") return [];

  try {
    const parsed = JSON.parse(body);
    return (parsed?.errors ?? []).map((error) => error?.message ?? "");
  } catch (e) {
    return [body];
  }
};

const collectMessages = (error) => {
  const errors = error?.errors ?? error?.data?.errors ?? [];
  const messages = [error?.message ?? ""];

  for (const entry of Array.isArray(errors) ? errors : []) {
    messages.push(entry?.message ?? "");
    messages.push(...parseMessagesFromBody(entry?.originalError?.response?.body));
  }

  return messages.filter(Boolean);
};

export const isSchemaMismatch = (error) => {
  const messages = Array.isArray(error) ? error.map((entry) => entry?.message ?? "") : collectMessages(error);

  return messages.some((message) => SCHEMA_MISMATCH_PATTERNS.some((pattern) => pattern.test(message)));
};

export const isMutation = (document) => {
  const operations = document?.definitions;

  if (Array.isArray(operations)) {
    return operations.some((definition) => definition?.operation === "mutation");
  }

  return typeof document === "string" && /^\s*mutation\b/i.test(document);
};

const lastReloadAt = () => {
  try {
    const stored = Number(window.sessionStorage.getItem(RELOAD_MARKER));
    return Number.isFinite(stored) && stored > 0 ? stored : null;
  } catch (e) {
    return null;
  }
};

const rememberReload = (at) => {
  try {
    window.sessionStorage.setItem(RELOAD_MARKER, String(at));
  } catch (e) {
    return false;
  }
  return true;
};

export const recoverFromStaleBundle = ({ reload = () => window.location.reload(), now = Date.now() } = {}) => {
  const previous = lastReloadAt();

  if (previous !== null && now - previous < RELOAD_COOLDOWN_MS) {
    return false;
  }

  if (!rememberReload(now)) {
    return false;
  }

  reload();
  return true;
};
